import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetsComponentsModule } from 'src/app/components/widgets/widgets-components.module';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PasswordStrengthBarComponent } from './password-strength-bar/password-strength-bar.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { NgSelectModule } from '@ng-select/ng-select';

import { DndDirective } from './file-uploader/direcitves/dnd.directive';
import { AmButtonModule } from '@angularminds/am-button';
import { WalletAccessComponent } from './wallet-access/wallet-access.component';
import { ChangeEmailComponent } from './change-email/change-email.component';

@NgModule({
  declarations: [
    InviteUserComponent,
    ConfirmationComponent,
    ChangePasswordComponent,
    PasswordStrengthBarComponent,
    FileUploaderComponent,
    DndDirective,
    WalletAccessComponent,
    ChangeEmailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetsComponentsModule,
    ModalModule.forRoot(),
    AmButtonModule,
    NgSelectModule
  ],
  exports: [InviteUserComponent, ConfirmationComponent, FileUploaderComponent, WalletAccessComponent, ChangeEmailComponent],
  entryComponents: [
    InviteUserComponent,
    ConfirmationComponent,
    ChangePasswordComponent,
    FileUploaderComponent,
    WalletAccessComponent,
    ChangeEmailComponent
  ],
})
export class MyModalModule { }
